<style lang="scss">
  @use "../../../../../assets/css/design-system/mixins";
  @use "../../../../../assets/css/design-system/utils";

  .right-slot {
    align-self: center;
    padding-right: utils.in_rem(12px);
  }

  .date-picker-selector {
    background: none;
    border: none;
    width: 100%;
    text-align: left;
    padding: 0;
  }
</style>

<script>
  import Icon from "../../../../atoms/Icon.svelte";
  import TextInput from "../../../InputFields/TextInput.svelte";
  import { getDatePickerContext } from "../context.svelte.js";

  let {
    showInfo = false,
    placeholder = "No date selected",
    label = "Select date",
    disabled = false,
    wrapperStyle = "flex-direction: row; align-items: center;",
  } = $props();

  const datePickerContext = getDatePickerContext();

  const LOCALE_WHITELIST = ["en-GB", "en-US"];
  const userLocale = new Intl.NumberFormat().resolvedOptions().locale;
  const LOCALE = LOCALE_WHITELIST.includes(userLocale) ? userLocale : "en-GB";

  let displayText = $derived(
    datePickerContext.selectedDate
      ? datePickerContext.formatDate(datePickerContext.selectedDate, LOCALE)
      : placeholder
  );

  const clickHandler = () => {
    datePickerContext.showModal = true;
  };
</script>

<button
  class="date-picker-selector"
  aria-label="Select date"
  onclick={clickHandler}
  {disabled}
>
  <TextInput
    {wrapperStyle}
    label="{label}{showInfo ? ' ' : ''}"
    readonly={true}
    value={displayText}
  >
    <div slot="right" class="right-slot">
      <Icon class="fa fa-calendar" />
    </div>
  </TextInput>
</button>
